import React from "react";
import "./Careers.css";

const Careerspage = () => {
  const backgroundImage = "https://endocardindia.com/wp-content/uploads/2023/03/Career-main-image-of-page-scaled.jpg"; // Replace with your image URL

  return (
    
    <section
      id="careers-section"
      
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "80vh", // Full viewport height
        display: "flex",
        alignItems: "center",
        justifyContent: "left",
    
      }}
    >
      <div className="blockcontent">
      
     {/* <h3>
       Define your career with <span className="highlight">Omega Review Solutions Pvt Ltd</span>
     </h3> */}
     <p>
      <h3>At <span className="highlight">Omega Review Solutions Pvt Ltd,</span></h3> we believe in fostering talent and providing opportunities for growth. We are always on the lookout for passionate individuals who are ready to make a difference and contribute to our innovative projects..
      grow with us in a collaborative and inclusive environment.<br/> To apply directly, please send your application to <a href="mailto:info@omegareviewsolutions.com">info@omegareviewsolutions.com</a>
     </p>

              
      </div>
    </section>
   
  );
};

export default Careerspage;
